<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const ONBOARDING = analyticsUtilities.events.ONBOARDING;

	module.exports = {
		components: {
			'article-a-day-promo-content': require('components/routes/onboarding/article-a-day-promo-content.vue').default
		},
		modelData: ['userContext'],
		methods: {
			eventClick(action_type) {
				let data = {
					step: 'article-a-day',
					action_type
				};
				fireEvent(ONBOARDING, data);
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main onboarding-article-a-day onboarding">
		<header class="onboarding-header">
			<div class="wrapper">
				<div class="account-name">{{ userContext.email }}</div>
			</div>
		</header>
		<div class="main-content wrapper">
			<h2 class="panel-title">This is how Article-A-Day works:</h2>
			<article-a-day-promo-content :event-click="eventClick"> </article-a-day-promo-content>
		</div>
	</main>
</template>
